import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('config.index', params);
    },
    get: (context, params) => {
        return apiService.get('config.detail', params);
    },
    create: (context, params) => {
        return apiService.post('config.index', params);
    },
    delete: (context, params) => {
        return apiService.delete('config.detail', params);
    },
    getMapView: async (context, key) => {
        const centerKey = `map_default_center_${key}`;
        const zoomKey = `map_default_zoom_${key}`;
        const list = await apiService.get('config.index', { key: `${centerKey},${zoomKey}` });
        const parse = value => {
            if (typeof value !== 'string') return value;
            try {
                return JSON.parse(value);
            } catch (error) {
                return value;
            }
        };
        const center = parse(list?.find(item => item.key === centerKey)?.value);
        const zoom = Number(parse(list?.find(item => item.key === zoomKey)?.value));
        const [lat, lng] = Array.isArray(center) ? center.map(Number) : [];
        if (!Number.isFinite(lat) || !Number.isFinite(lng) || !Number.isFinite(zoom)) return null;
        return { center: [lat, lng], zoom };
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
